<div class="wrapper">
  <div class="header">{{ name }}</div>
  <span class="roles">{{ roles }}</span>
  <div class="divider"></div>
  <div class="footer">
    <div class="logout" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </div>
    <app-version cssClass="versionText-blue"></app-version>
  </div>
</div>
